import {
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Theme } from 'b2b-theme';
import * as $ from 'jquery';
import * as _ from 'lodash';

import { environment } from '../../../environments/environment';
import { Section } from '../../models/Section';
import { SelectItem } from '../../models/SelectItem';
import { AuthorizationService } from '../../services/authorization.service';
import { GlobalFilterService } from '../../services/global-filter.service';

declare function initializeHealthcareTopBarV2(
  parentContainer: JQuery,
  auth0ClientId: string,
  auth0Domain: string,
  auth0RefreshToken: boolean,
  auth0Scope: string
): Promise<any>;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  private topBarLoaded = false;
  public readonly apptitle = environment.applicationDisplayName;
  readonly healthcareContractManagementLink = `${environment.cmUrlRoot}/#`;

  public usersClients: SelectItem[] = [];
  public clientsLoaded = false;

  @Input() sections: Section[];
  @ViewChild('ul') ul: ElementRef;
  @ViewChild('sidenav') public sidenav: MatSidenav;
  hamburger = false;
  public innerWidth: any;
  public sectionNameLength: any;
  validSections = [];

  constructor(
    private globalFilterService: GlobalFilterService,
    private authorizationService: AuthorizationService
  ) {}

  @HostListener('window:resize', ['$event'])
  onResize(event): void {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth >= 1500) {
      this.sidenav.close();
    }
    this.setHamburger();
  }

  async ngOnInit() {
    this.innerWidth = window.innerWidth;

    if (this.topBarLoaded) {
      return;
    }

    try {
      await this.injectHealthcareTopBar();

      Theme;

      let topBar = await initializeHealthcareTopBarV2(
        $('#healthcareTopBar'),
        environment.auth0.clientId,
        environment.auth0.domain,
        environment.auth0.refreshToken,
        environment.auth0.scope
      );

      await topBar.initialize();
      window['healthcareTopBar'] = topBar;
      this.authorizationService.setHealthcareTopBar(topBar);
      await this.authorizationService.waitUntilReady();
      this.topBarLoaded = true;

      this.setValidSections();

      this.globalFilterService.ClientsLoaded.subscribe((response) => {
        _.forEach(this.globalFilterService.clients, (client) => {
          this.usersClients.push({
            label: `${client.ClientId} - ${client.ClientName}`,
            value: client.ClientId,
          });
        });
        this.clientsLoaded = true;
      });

      await this.globalFilterService.loadClients();

      this.authorizationService.HealthcareTopBar.notifyActivity();
    } catch (error) {
      console.log(error);
    }

    this.getSectionNameLength();
    this.setHamburger();
  }

  private setValidSections(): void {
    this.validSections = this.sections.filter(
      (section) =>
        !section.subSection &&
        this.authorizationService.hasFeature(section.feature, true)
    );
  }

  clientSelected(event: any) {
    this.globalFilterService.selectedClientId = event.value;
  }

  injectHealthcareTopBar(): Promise<any> {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.async = true;
      script.src = environment.healthcareTopBar;
      script.addEventListener('load', resolve);
      script.addEventListener('error', () => reject('Error loading script.'));
      script.addEventListener('abort', () => reject('Script loading aborted.'));
      document.body.appendChild(script);
    });
  }

  checkValidLink(feature: string): boolean {
    if (!feature || !this.authorizationService.hasFeature(feature)) {
      return false;
    }
    return true;
  }

  hasFeature(name: string): boolean {
    const result = name ? this.authorizationService.hasFeature(name) : false;
    return result;
  }

  setHamburger(): void {
    this.hamburger = false;
    if (this.sectionNameLength > 50) {
      this.hamburger = true;
    }
    if (this.innerWidth < 1470) {
      this.hamburger = true;
    }
  }

  getSectionNameLength(): void {
    const tempSectionsArray = this.sections;
    this.sectionNameLength = tempSectionsArray
      .map((item) => item.name.length)
      .reduce((prev, next) => prev + next);
  }
}
